import React from "react";
import { apiUrls } from "../../../actprep-ui/utils/urls";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import ContentBox from "../../../actprep-ui/components/ContentBox";
import PaginatedTable from "../../../actprep-ui/components/PaginatedTable";
import layout from "../../../actprep-ui/constants/layout";
import LessonsForm from "../../../components/EditLessonsForm";
import { capitalize } from "../../../actprep-ui/utils/formatting";
import { sortingModes } from "../../../actprep-ui/constants/dataGrid";

export default function Lessons() {
  const lessonsColumns = () => [
    {
      field: "name",
      headerName: "Name",
      width: 250,
    },
    {
      field: "subject",
      headerName: "Subject",
      width: 100,
      valueFormatter: (val) => capitalize(val),
    },
    {
      field: "category",
      headerName: "Category",
      width: 200,
      valueGetter: (val, row) => `${row.category?.name || ""}`,
    },
    {
      field: "can_embed",
      headerName: "Can Embed",
      width: 100,
      type: "boolean",
    },
    {
      field: "link",
      headerName: "Link",
      width: 300,
    },
  ];

  return (
    <Grid
      sx={{
        marginTop: `${layout.navBarHeight + 1}rem`,
      }}
      size={12}
    >
      <ContentBox style={{ maxHeight: "80vh", height: "500rem" }}>
        <Typography variant="h5" fontWeight={"bold"}>
          Lessons
        </Typography>
        <Box sx={{ height: "90%" }}>
          <PaginatedTable
            searchable
            tableName={"Lessons"}
            addRowButtonText="Add Lesson"
            apiUrl={apiUrls.admin.lessons()}
            columns={lessonsColumns}
            urlParams={{
              keep_related: "true",
            }}
            initialState={{
              pinnedColumns: {
                right: ["actions"],
              },
            }}
            sortingMode={sortingModes.SERVER}
            disableCellFocus
            getRowTitle={({ row }) => row?.name}
            EditForm={LessonsForm}
            CreationForm={LessonsForm}
          />
        </Box>
      </ContentBox>
    </Grid>
  );
}
